/* McAdventures theme - stage 1. Vanilla JS. */
(function () {
  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  // Shop filter buttons
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    var scope = document.querySelector(group.getAttribute('data-filter-group')) || document;
    var btns = group.querySelectorAll('[data-filter]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filter');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        scope.querySelectorAll('[data-kind]').forEach(function (c) {
          var show = f === 'all' || c.getAttribute('data-kind') === f;
          c.style.display = show ? '' : 'none';
        });
      });
    });
  });

  // Product page: thumbnails, quantity, add to cart
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var main = root.querySelector('[data-main-img]');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || ''; }
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('on', x === t); });
      });
    });

    var form = root.querySelector('[data-add-form]');
    if (!form) return;
    var price = parseInt(form.getAttribute('data-price'), 10) || 0;
    var threshold = parseInt(form.getAttribute('data-threshold'), 10) || 0;
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qtyOut = form.querySelector('[data-qty]');
    var total = form.querySelector('[data-line-total]');
    var status = root.querySelector('[data-status]');
    var btn = form.querySelector('[data-atc]');
    var qty = 1;

    function render() {
      qtyInput.value = qty;
      if (qtyOut) qtyOut.textContent = qty;
      if (total) total.textContent = money(price * qty);
    }
    var dec = form.querySelector('[data-dec]');
    var inc = form.querySelector('[data-inc]');
    if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); if (status) status.hidden = true; render(); });
    if (inc) inc.addEventListener('click', function () { qty += 1; if (status) status.hidden = true; render(); });
    render();

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (btn) btn.disabled = true;
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          if (status) {
            var left = threshold - cart.total_price;
            status.textContent = 'Added to your cart. ' + (left > 0 ? 'Add ' + money(left) + ' more for free standard shipping.' : 'You have free standard shipping.');
            status.hidden = false;
          }
          if (btn) btn.disabled = false;
        })
        .catch(function () { form.submit(); });
    });
  });
})();